import { isEmpty } from 'lodash'

import { http } from '@/plugins/http'
import Vuex from '@/store'

import Token from './token'

import * as TYPES from './../vuex/mutations-types'

const setUser = (user) => Vuex.commit(TYPES.SET_USER, user)

export const attemptLogin = ({ username, password }) => {
  const headers = { 'x-request-login': true }
  return http.post('/auth/token/issue', { username, password }, { headers })
    .then((response) => response.data)
    .then(({ token }) => {
      Token.store(token)
      return loadUserData
    })
}

export const logout = () => {
  Token.store(null)
  setUser({})
  return Promise.resolve()
}

export const refreshToken = () => {
  const headers = { 'x-request-login': true }
  return http.post('/auth/token/refresh', { }, { headers })
    .then((response) => response.data)
    .then(({ token }) => {
      Token.store(token)
      return token
    })
}

export const loadUserData = () => {
  const user = Vuex.state.Auth.user

  if (!isEmpty(user.name)) {
    return Promise.resolve(user)
  }

  return http.get('/auth/me')
    .then(response => response.data)
    .then(({ data }) => {
      setUser(data)
      return data
    })
}

export const checkIsTokenExists = () => {
  return Token.load()
    .then(() => loadUserData())
}

export default { attemptLogin, logout }



// WEBPACK FOOTER //
// ./src/app/auth/services/index.js